export const footer_i18n = {
    text1: "Privacidad",
    text2: "Términos",
    text3: "Mapa del sitio"
};